export const EMPTY_BRANCH_FORM = {
  name: "",
  address: "",
  phone: "",
  description: "",
  images: [],
};

export const BRANCH_STATUS_LABELS = {
  ACTIVE: "Hoạt động",
  INACTIVE: "Ngừng hoạt động",
};
